export default class SubscriptionService {
    // Initializing important variables
    constructor(domain) {
    }
  getUrl(){
    var loc = window.location;
    var url = new URL(loc)
    var enviorment_url = url.hostname
    if(enviorment_url == "booking-staging.getspiffy.com"){
      return "https://staging.getspiffy.com/api/v1/"
    }
    else if(enviorment_url == "booking.getspiffy.com"){
      return "https://my.getspiffy.com/api/v1/"
    }
    else {
      return "http://localhost:3000/api/v1/"
    }
  }

  getSubscriptions() {
    console.log("getting subscriptions!")
    var prefix = this.getUrl()
    var url = prefix + "customer_subscriptions.json"
    return fetch(url, {
      method: "GET",
      //mode: 'no-cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Auth-Token': localStorage.getItem('id_token'),
      }
    })
    .then((response) => response.json())
    .then(response => {
      return response;
    })
    .catch((error) => {
      //alert('Unable to login, please double check email and password are entered correctly.');
      });
  }

  saveSubscription(subscriptionId, addressId, vehicleId, startDate){
    var prefix = this.getUrl()
    var url = prefix + "create_customer_subscription.json"
    var data = {
      customer_subscription: {
        subscription_id: subscriptionId,
        address_id: addressId,
        vehicle_id: vehicleId,
        start_date: startDate
      }
    }
    return fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
       headers: {
         'X-Auth-Token': localStorage.getItem('id_token')
       }

    })
    .then((response) => response.json())
    .then(response => {
      return response;
    })
    .catch((error) => {
      console.log("catch")
      //alert('Unable to login, please double check email and password are entered correctly.');
      });
  }

  plans(vehicle_id) {
    console.log("getting subscriptions!")
    var prefix = this.getUrl()
    var url = prefix + "subscriptions.json?vehicle_id= " + vehicle_id
    return fetch(url, {
      method: "GET",
      //mode: 'no-cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Auth-Token': localStorage.getItem('id_token'),
      }
    })
    .then((response) => response.json())
    .then(response => {
      return response;
    })
    .catch((error) => {
      //alert('Unable to login, please double check email and password are entered correctly.');
      });
  }
}



// WEBPACK FOOTER //
// ./src/utils/SubscriptionService.js